import React from "react";
import ReactModal from "react-modal";
import moment from "moment";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFEBEA",
    padding: "4em",
  },
};

const UserQueryAlert = ({modalFlag, queryMessage= "", modalFunc }) => {
  return (
    <div>
      <ReactModal
        isOpen={modalFlag}
        style={customStyles}
        contentLabel="Appointment Query"
        ariaHideApp={false} 
      >
        
        
        <h3 className="text-navyBlue">Appointment Query </h3>
        <div className="mt-10 mb-20 ">

       
        <p><strong>Appointment Query:  </strong> {queryMessage|| "No user query "} </p>
        </div>
        

        <div className="mt-10 btn-wrapper">
         
          <button
            className="btn-sm  btn-outline-red rounded-5"
            onClick={() => modalFunc(false)}
          >
            Close
          </button>
        </div>
      </ReactModal>
    </div>
  );
};

export default UserQueryAlert;
